import * as types from '@store/types'
import shortly from 'vuex-shortly'
import axios from 'axios'
import formatedFilters from '@helpers/formatAxiosGetFilters'

const state = {
  award: {},
  awards: [],
  paginate: {}
}

const getters = {
  [types.AWARD]: 'award',
  [types.AWARDS]: 'awards',
  [types.AWARDS_PAGINATE]: 'paginate'
}

const mutations = {
  [types.AWARD]: 'award',
  [types.AWARDS]: 'awards',
  [types.AWARDS_PAGINATE]: 'paginate'
}

const actions = {
  [types.AWARD]: async ({ commit }, awardId) => {
    const response = await axios.get(`awards/${awardId}`)
    const award = response.data?.data || {}

    commit(types.AWARD, award || {})
  },

  [types.AWARDS]: async ({ commit }, params = '') => {
    const filters = formatedFilters(params)

    const response = await axios.get(`awards?${filters}`)
    const awards = response.data?.data || {}
    const pagination = response.data?.meta || {}

    commit(types.AWARDS, awards || [])
    commit(types.AWARDS_PAGINATE, pagination || {})
  },

  [types.AWARD_UPDATE]: async ({ commit, dispatch }, payload) => {
    const response = await axios.patch('awards', payload)
      .then((res) => {
        dispatch(types.NOTIFICATIONS_INCLUDE, {
          type: 'success',
          message: 'Premiação alterada com sucesso!'
        })

        return res
      }, () => {
        dispatch(types.NOTIFICATIONS_INCLUDE, {
          type: 'error',
          message: 'Ocorreu um erro!'
        })
        return false
      })
    return response
  },

  [types.AWARDS_CONFIRM]: async ({ dispatch }, payload) => {
    const awards = payload.map(award => award.id)
    await axios.post('awards/group/patch', {
      ids: awards
    }).then((res) => {
      dispatch(types.NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Premiações confirmadas com sucesso!'
      })

      return res
    }, () => {
      dispatch(types.NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message: 'Ocorreu um erro!'
      })
      return false
    })
    await dispatch(types.AWARDS)
  },

  [types.AWARDS_CANCEL]: async ({ dispatch }, payload) => {
    const awards = payload.map(award => award.id)
    await axios.post('awards/group/patch', {
      ids: awards
    }).then((res) => {
      dispatch(types.NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Premiações canceladas com sucesso!'
      })

      return res
    }, () => {
      dispatch(types.NOTIFICATIONS_INCLUDE, {
        type: 'error',
        message: 'Ocorreu um erro!'
      })
      return false
    })
    await dispatch(types.AWARDS)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/awards.js